import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory as history } from 'react-router';

import moment from 'moment';
import 'moment-duration-format';

import Label from '@zacousticrepo/grommet-v1-custom/components/Label';
import SelectQuestionType from './SelectQuestionType';
import SelectQuestionFromTemplate from './SelectQuestionFromTemplate';
import QuestionEditor from './QuestionEditor';
import FreeTextQuestionIcon from '../../../icons/v3/FreeTextQuestionIcon';
import MultipleChoiceQuestionIcon from '../../../icons/v3/MultipleChoiceQuestionIcon';
import OpinionScaleQuestionIcon from '../../../icons/v3/OpinionScaleQuestionIcon';
import YesNotQuestionIcon from '../../../icons/v3/YesNotQuestionIcon';
import GoBackIcon from '../../../icons/v3/GoBackIcon';
import BackArrowIcon from '../../../icons/v3/BackArrowIcon';
import { isDefined } from '../../../utils';

class SurveyCreator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSurvey: {
                questions: [],
            },
            currentQuestion: undefined,
            showAddNewQuestionPopUp: false,
            showAddNewQuestionFromTemplatePopUp: false,
            isHovering: false
        };

        this.backToSearch = this.backToSearch.bind(this);

        this.showAddNewQuestionPopUp = this.showAddNewQuestionPopUp.bind(this);
        this.closeAddNewQuestionPopUp = this.closeAddNewQuestionPopUp.bind(this);

        this.showAddNewQuestionFromTemplatePopUp = this.showAddNewQuestionFromTemplatePopUp.bind(this);
        this.closeAddNewQuestionFromTemplatePopUp = this.closeAddNewQuestionFromTemplatePopUp.bind(this);

        this.getLeftBar = this.getLeftBar.bind(this);
        this.getQuestionEditor = this.getQuestionEditor.bind(this);
        this.getQuestionTypeIcon = this.getQuestionTypeIcon.bind(this);

        this.saveQuestion = this.saveQuestion.bind(this);
        this.saveSurvey = this.saveSurvey.bind(this);

        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);

    }

    //componentDidMount() {

    //}

    backToSearch() {
        const
            {
                backToSurveysScreen
            } = this.props;
        backToSurveysScreen();
    }

    addNewQuestion() {
        this.setState({ currentQuestion: {} });
    }

    showAddNewQuestionPopUp() {
        this.setState({ showAddNewQuestionPopUp: true });
    }

    closeAddNewQuestionPopUp(surveyQuestionType) {
        this.setState({
            showAddNewQuestionPopUp: false,
        });
        if (isDefined(surveyQuestionType) && Array.isArray(surveyQuestionType) && surveyQuestionType.length > 0) {
            const currentQuestion = {
                type: surveyQuestionType[0]
            };
            switch (surveyQuestionType[0].value) {
                case 'Multiple Answer':
                case 'Opinion Scale':
                    currentQuestion.choices = [
                        {
                            id: 1,
                            value: ''
                        }];
                    break;
                case 'Yes/No':
                    currentQuestion.choices = [
                        {
                            id: 1,
                            value: 'Yes'
                        },
                        {
                            id: 2,
                            value: 'No'
                        }];
                    break;
                case 'Free Text':

                    break;
                default:
            }

            this.setState({
                currentQuestion: currentQuestion,
            });
        }
    }

    showAddNewQuestionFromTemplatePopUp() {
        this.setState({ showAddNewQuestionFromTemplatePopUp: true });
    }

    closeAddNewQuestionFromTemplatePopUp(surveyQuestion) {
        this.setState({
            showAddNewQuestionFromTemplatePopUp: false,
        });
        if (isDefined(surveyQuestion)) {
            this.setState({
                currentQuestion: surveyQuestion,
            });
        }
    }

    saveQuestion(questionToAddToSurvey) {
        this.setState({ currentQuestion: undefined });

        if (isDefined(questionToAddToSurvey)) {
            const currentSurveyUpdated = this.state.currentSurvey;
            currentSurveyUpdated.questions.push(questionToAddToSurvey);
            this.setState({ currentSurvey: currentSurveyUpdated });
        }
    }

    saveSurvey() {
        const
            {
                newSurvey,
                saveSurvey
            } = this.props;
        this.state.currentSurvey.name = newSurvey.name;
        this.state.currentSurvey.type = newSurvey.type;
        saveSurvey(this.state.currentSurvey);
    }

    handleMouseOver() {
        this.setState({ isHovering: true });
    }

    handleMouseOut() {
        this.setState({ isHovering: false });
    }

    getQuestionTypeIcon(question) {
        let icon;
        switch (question.type.value) {
            case 'Multiple Answer':
                icon = <MultipleChoiceQuestionIcon />
                break;
            case 'Opinion Scale':
                icon = <OpinionScaleQuestionIcon />
                break;
            case 'Yes/No':
                icon = <YesNotQuestionIcon />
                break;
            case 'Free Text':
                icon = <FreeTextQuestionIcon />
                break;
            default:
        }
        return icon;
    }

    getLeftBar() {
        const
            {
                newSurvey
            } = this.props;
        const questions = this.state.currentSurvey.questions.map((q, i) => {
            const icon = this.getQuestionTypeIcon(q);
            return (
                <div key={i} className="flex-container-start bordered-div" style={{ margin: '10px 0', padding: '6px' }}>
                    <div className="flex-container" style={{ marginRight: '10px' }}>{icon}</div>
                    <div>{q.name}</div>
                </div>);
        });

        const backButton = (<div style={{ margin: '4px' }}>
            <Link className="flex " onClick={() => this.backToSearch()}>
                <span className="cursor-pointer" ><BackArrowIcon /></span>
                <Label className="cursor-pointer" style={{ fontSize: '18px', marginLeft: '8px' }} >{'back'}</Label>
            </Link>
        </div>);

        //const backButton = (<div style={{ margin: '10px 0 20px 0', cursor: 'pointer' }}>
        //    <Link onClick={() => this.backToSearch()}>
        //        <div className="flex-container-start">
        //            <div style={{ margin: '4px 10px 3px 0' }}>
        //                <GoBackIcon />
        //            </div>
        //            <div style={{ marginBottom: '4px' }}>
        //                <Label className="back-button">Back to List</Label>
        //            </div>
        //        </div>
        //    </Link>
        //</div>);

        const addNewQuestionButton = (
            <div
                className="add-new-question-button flex-container-center"
                style={{ width: '155px', margin: '0' }}
                onClick={this.showAddNewQuestionPopUp}>
                Manually
            </div>);
        const addNewQuestionFromemplateButton = (
            <div
                className="add-new-question-button flex-container-center"
                style={{ width: '155px', margin: '0' }}
                onClick={this.showAddNewQuestionFromTemplatePopUp}>
                From Template
            </div>);
        const saveSurveyButton = (
            <div className="v3-button agent-view-interactions"
                style={{
                    display: 'block', bottom: '100px', position: 'fixed'
                }}
                onClick={this.saveSurvey}>
                Save Survey
            </div>);
        return (<div style={{ minWidth: '360px', background: '#FDF9FB', padding: '0 20px', height: '100vh', margin: '0 25px' }}>
            {backButton}
            <div className="survey-title">Survey Name: {newSurvey.name}</div>
            <div className="survey-title" style={{ marginBottom: '30px' }}>Survey Type: {newSurvey.type}</div>
            {questions}
            <div>
                {/*
                {newSurvey.type === 'qa' &&
                    <div className="add-new-question-button flex-container-center" style={{ margin: '10px auto' }}>
                        Add new secttion
                    </div>}
                */ }
                {!this.state.isHovering &&
                    <div className="add-new-question-button flex-container-center" onMouseOver={this.handleMouseOver}>
                        Add new question
                    </div>}
                {this.state.isHovering && //onMouseOut
                    <div className="flex flex-space-between" onMouseLeave={this.handleMouseOut}>
                        {addNewQuestionButton}
                        {addNewQuestionFromemplateButton}
                    </div>
                }
            </div>
            {saveSurveyButton}
        </div>)
    }

    getQuestionEditor() {
        if (!isDefined(this.state.currentQuestion)) {
            return undefined;
        }
        return (<div style={{ padding: '20px', width: 'inherit' }}>
            <QuestionEditor
                currentQuestion={this.state.currentQuestion}
                onSave={this.saveQuestion} />
        </div>)
    }

    render() {
        const
            {
                newSurvey
            } = this.props;
        const leftBar = this.getLeftBar();
        const questionEditor = this.getQuestionEditor();
        return (
            <div>
                <div className="main-page-width flex-container-start-align-start" style={{ margin: '0' }}>
                    {leftBar}
                    {questionEditor}
                </div>
                {this.state.showAddNewQuestionPopUp &&
                    <div className="modal displayBlock" >
                        <div className="modal-content modal-content-selectReasonForContact">
                            <SelectQuestionType
                                onClose={this.closeAddNewQuestionPopUp} />
                        </div>
                    </div>}
                {this.state.showAddNewQuestionFromTemplatePopUp &&
                    <div className="modal displayBlock" >
                        <div className="modal-content modal-content-selectLikertScale">
                            <SelectQuestionFromTemplate
                                surveyType={newSurvey.type}
                                onClose={this.closeAddNewQuestionFromTemplatePopUp} />
                        </div>
                    </div>}
            </div>
        );
    }
}

const select = state => ({});

export default connect(select)(SurveyCreator);